export enum Companies {
  W3LCOME = 'w3lcome',
  INVENZI = 'invenzi',
  ENIDMA = 'enidma',
}
